// utils/pkce.js

const pkceTag = 'pkce_verifier';

function base64urlEncode(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

async function sha256(input) {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  return crypto.subtle.digest('SHA-256', data);
}

export const generatePKCE = async () => {
  const verifier = [...crypto.getRandomValues(new Uint8Array(32))]
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
  return {
    verifier,
    challenge: base64urlEncode(await sha256(verifier)),
  };
}

export const setPKCE = async () => {
  const { verifier, challenge } = await generatePKCE();
  sessionStorage.setItem(pkceTag, verifier);
  return { verifier, challenge };
}

export const getPKCE = () => {
  const verifier = sessionStorage.getItem(pkceTag);
  sessionStorage.removeItem(pkceTag);
  return verifier;
}